"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toJSON = exports.removeUndefinedValuesFromAllArrays = exports.noop = exports.isIn = exports.isFn = exports.is = exports.invokeSafely = exports.invokeInSafely = exports.hasKeys = exports.getTopKey = exports.getBottomKey = exports.getAllPossibleKeys = exports.fillKeys = exports.countKeys = exports.clean = void 0;
var _lodash = require("lodash");
var _flat = _interopRequireDefault(require("flat"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const hasKeys = o => o !== null && typeof o === 'object' && Object.keys(o).length > 0;
exports.hasKeys = hasKeys;
const countKeys = o => hasKeys(o) ? Object.keys(o).length : 0;
exports.countKeys = countKeys;
const is = o => hasKeys(o) ? o : {};
exports.is = is;
const isFn = fn => typeof fn === 'function';
exports.isFn = isFn;
const isIn = (target, keyName) => hasKeys(target) && keyName in target;
exports.isIn = isIn;
const invokeSafely = function (fn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return isFn(fn) ? fn(...args) : null;
};
exports.invokeSafely = invokeSafely;
const invokeInSafely = function (obj, methodName) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }
  return isIn(obj, methodName) && isFn(obj[methodName]) ? obj[methodName](...args) : undefined;
};
exports.invokeInSafely = invokeInSafely;
const getAllPossibleKeys = a => Object.keys(a.reduce((res, item) => ({
  ...res,
  ...(0, _flat.default)(item)
}), {}));
exports.getAllPossibleKeys = getAllPossibleKeys;
const fillKeys = (keys, target) => keys.reduce((result, key) => Object.assign(result, {
  [key]: (0, _lodash.get)(target, key, '')
}), {});
exports.fillKeys = fillKeys;
const clean = function () {
  let target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.entries(target).reduce((acc, _ref) => {
    let [key, value] = _ref;
    if (Array.isArray(value)) {
      const inner = value.map(clean).filter(Boolean).filter(hasKeys); // only allow through populated arrays

      if (inner.length) acc[key] = inner;
    } else if (hasKeys(value)) {
      const inner = clean(value); // only allow through populated objects

      if (hasKeys(inner)) acc[key] = inner; // only allow through populated values
    } else if (value !== null && value !== undefined && typeof value !== 'object') {
      acc[key] = value;
    }
    return acc;
  }, {});
};
exports.clean = clean;
const removeUndefinedValuesFromAllArrays = function () {
  let target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.entries(target).reduce((acc, _ref2) => {
    let [key, value] = _ref2;
    if (Array.isArray(value)) {
      acc[key] = value.map(item => hasKeys(item) ? removeUndefinedValuesFromAllArrays(item) : item).filter(item => item !== undefined);
    } else if (hasKeys(value)) {
      acc[key] = removeUndefinedValuesFromAllArrays(value);
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});
};
exports.removeUndefinedValuesFromAllArrays = removeUndefinedValuesFromAllArrays;
const getBottomKey = v => (0, _lodash.last)(Object.keys(v));
exports.getBottomKey = getBottomKey;
const getTopKey = v => (0, _lodash.first)(Object.keys(v));
exports.getTopKey = getTopKey;
const toJSON = xs => {
  try {
    return JSON.stringify(xs);
  } catch (e) {
    return xs;
  }
};
exports.toJSON = toJSON;
const noop = promise => promise.then(() => {// noop
}).catch(() => {// noop
});
exports.noop = noop;